import BigNumber from 'bignumber.js';
import { PublicClient } from 'viem';

import {
  AVG_SECONDS_IN_YEAR,
  BLOCKS_PER_SECOND,
  POOLS_LIMIT,
} from 'modules/api/const';
import { getMainTokenContract } from 'modules/api/contracts/getMainTokenContract';
import { memoizePromise } from 'modules/api/methods/memoizePromise';
import { convertFromWei } from 'modules/api/utils';

async function _getPoolShares(client: PublicClient): Promise<BigNumber> {
  const tokenContract = getMainTokenContract(client);
  const blockReward = await tokenContract.read.getCurrentBlockReward();

  return new BigNumber(convertFromWei(blockReward))
    .multipliedBy(BLOCKS_PER_SECOND)
    .multipliedBy(AVG_SECONDS_IN_YEAR)
    .div(POOLS_LIMIT * 2);
}

export const getPoolShares = memoizePromise(_getPoolShares, client => {
  return `${client?.chain?.id || 'unknown'}`;
});
